import { render, staticRenderFns } from "./membership_footer.vue?vue&type=template&id=c3863010&scoped=true&"
import script from "./membership_footer.vue?vue&type=script&lang=ts&"
export * from "./membership_footer.vue?vue&type=script&lang=ts&"
import style0 from "./membership_footer.vue?vue&type=style&index=0&id=c3863010&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3863010",
  null
  
)

export default component.exports